module.exports = __webpack_public_path__ + "images/058c39bff352d25b560f7a366997081a.svg";